'use client';

import { Dispatch, ReactNode } from 'react';
import { LandingResponse } from '@/modules/contents/web.interface';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import Link from 'next/link';
import { ITab } from './indexMain';
import { useRouter } from 'next/navigation';
import styles from './hero.module.less';

export const tabs: ITab[] = [
  {
    tab: 'twitter',
    title: 'Twitter',
    href: '/shadowban-test/twitter-shadowban-test',
    icon: '/images/social/x.svg',
  },
  {
    tab: 'instagram',
    title: 'Instagram',
    href: '/shadowban-test/instagram-shadowban-test',
    icon: '/images/social/instagram.svg',
  },
  {
    tab: 'tiktok',
    title: 'TikTok',
    href: '/shadowban-test/tiktok-shadowban-test',
    icon: '/images/social/tiktok.svg',
  },
];

export default function Hero({
  children,
  landingData,
  currentTab,
  setCurrentTabAction,
  tabRedirect,
  isSubPage,
}: {
  children: ReactNode;
  landingData: LandingResponse;
  currentTab: ITab['tab'];
  setCurrentTabAction: Dispatch<ITab['tab']>;
  tabRedirect: boolean;
  isSubPage: boolean;
}) {
  const router = useRouter();
  const { contentInfo } = landingData;
  const LinkTag = tabRedirect ? Link : 'button';

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          <div className={styles.innerContent}>
            <h1 className={styles.title}>
              {contentInfo.hero.title}
            </h1>

            <p className={styles.description}>
              {contentInfo.hero.desc}
            </p>

            <div className={styles.tabsWrapper}>
              {tabs.map((item) => (
                <LinkTag
                  key={item.tab}
                  className={cn(
                    styles.tabButton,
                    currentTab === item.tab && styles.active
                  )}
                  href={item.href}
                  onClick={() => {
                    setCurrentTabAction(item.tab);
                    if (isSubPage) {
                      router.push(item.href);
                    }
                  }}
                >
                  <Image
                    src={item.icon}
                    width={32}
                    height={32}
                    alt={item.title}
                    className={styles.icon}
                  />
                  {item.title}
                </LinkTag>
              ))}
            </div>
            {children}
          </div>
        </div>
      </div>
    </section>
  );
}
